import { render } from "./RecruitView.vue?vue&type=template&id=0d8c7551&scoped=true"
import script from "./RecruitView.vue?vue&type=script&lang=js"
export * from "./RecruitView.vue?vue&type=script&lang=js"

import "./RecruitView.vue?vue&type=style&index=0&id=0d8c7551&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8c7551"]])

export default __exports__